export const META_TAGS = {
  home: {
    title: "Home - Shape Shifting Mastery",
    description: "Transform your body and life with Shape Shifting Mastery. Expert guidance in body transformation and personal development.",
    keywords: "shape shifting, body transformation, personal development, fitness transformation",
    ogTitle: "Shape Shifting Mastery - Transform Your Body & Life",
    ogDescription: "Begin your transformation journey with expert guidance and proven techniques."
  },
  about: {
    title: "About Us - Shape Shifting Mastery",
    description: "Learn about our journey, mission, and expertise in body transformation. Discover how we help people achieve their transformation goals.",
    keywords: "about us, shape shifting experts, transformation specialists, body transformation journey",
    ogTitle: "About Shape Shifting Mastery - Our Journey & Mission",
    ogDescription: "Discover our story and how we've helped countless individuals transform their bodies and lives."
  },
  // Add more pages as needed
  services: {  // Add services meta tags
    title: "Services - Shape Shifting Mastery",
    description: "Explore our comprehensive range of transformation services. From personalized coaching to group programs.",
    keywords: "transformation services, coaching, fitness programs, personal training, body transformation services",
    ogTitle: "Our Services - Shape Shifting Mastery",
    ogDescription: "Discover our range of transformation services designed to help you achieve your goals."
  },
  contact: {
    title: "Contact Us - Shape Shifting Mastery",
    description: "Gett in touch with Shape Shifting Mastery. Start your transformation journey today.",
    keywords: "contact, enquiry, transformation coaching, get started",
    ogTitle: "Contact Shape Shifting Mastery",
    ogDescription: "Ready to start your transformation? Contact us today."
  },

shop: {
    title: "Shop - Shape Shifting Mastery Products",
    description: "Discover our curated selection of transformation tools, supplements, and resources to support your fitness journey.",
    keywords: "fitness products, transformation tools, supplements, fitness equipment, workout gear",
    ogTitle: "Shop Shape Shifting Mastery Products",
    ogDescription: "Explore our curated selection of transformation tools, supplements, and resources to support your fitness journey."
  },

  podcasts: {
    title: "Podcasts - Shape Shifting Mastery",
    description: "Listen to expert insights, transformation stories, and practical tips for your fitness journey. Weekly episodes on body transformation and personal development.",
    keywords: "fitness podcasts, transformation stories, expert interviews, fitness tips, wellness podcasts",
    ogTitle: "Podcasts - Shape Shifting Mastery",
    ogDescription: "Listen to expert insights, transformation stories, and practical tips for your fitness journey. Weekly episodes on body transformation and personal development."
  },
  "shape-shifting-mastery": {
    title: "Welcome to Shape Shifting Mastery",
    description: "Begin your transformation journey with Shape Shifting Mastery. Learn about our proven methods and success stories in body transformation.",
    keywords: "shape shifting mastery, body transformation program, fitness transformation, lifestyle change",
    ogTitle: "Welcome to Shape Shifting Mastery",
    ogDescription: "Begin your transformation journey with Shape Shifting Mastery. Learn about our proven methods and success stories in body transformation."
   },

  "upcoming-session-info": {
    title: "Upcoming Sessions - Shape Shifting Mastery",
    description: "Join our upcoming online transformation sessions. Live coaching, expert guidance, and interactive workshops for your fitness journey.",
    keywords: "online fitness sessions, live coaching, transformation workshops, virtual fitness classes",
    ogTitle: "Upcoming Sessions - Shape Shifting Mastery",
    ogDescription: "Join our upcoming online transformation sessions. Live coaching, expert guidance, and interactive workshops for your fitness journey."
  },
  "success-stories": {
    title: "Success Stories - Shape Shifting Mastery",
    description: "Real transformation stories from our community. See how Shape Shifting Mastery has helped people achieve their fitness goals.",
    keywords: "transformation success stories, fitness results, before and after, client testimonials",
    ogTitle: "Success Stories - Shape Shifting Mastery",
    ogDescription: "Real transformation stories from our community. See how Shape Shifting Mastery has helped people achieve their fitness goals."
  },

  blogs: {
    title: "Blogs - Shape Shifting Mastery",
    description: "Expert articles on fitness, nutrition, mindset, and transformation. Stay updated with the latest insights and tips for your journey.",
    keywords: "fitness blog, transformation tips, nutrition advice, wellness articles, fitness insights",
    ogTitle: "Blogs - Shape Shifting Mastery",
    ogDescription: "Expert articles on fitness, nutrition, mindset, and transformation. Stay updated with the latest insights and tips for your journey."
  },

"blogs/:category/:seo_url_slug": (blogData) => ({
    title: blogData?.seo_title_en || blogData?.title || "Blog - Shape Shifting Mastery",
    description: blogData?.seo_description_en || `Read about ${blogData?.title} on Shape Shifting Mastery.`,
    keywords: blogData?.seo_keywords || "shape shifting mastery, body transformation, fitness journey, wellness tips",
    ogTitle: blogData?.seo_title_en || blogData?.title || "Blog - Shape Shifting Mastery",
    ogDescription: blogData?.seo_description_en || `Read about ${blogData?.title} on Shape Shifting Mastery.`,
    ogType: "article",
    ogImage: blogData?.photo_file || "",
    author: blogData?.user?.name || "Shape Shifting Mastery",
    publishDate: blogData?.date,
    category: blogData?.Joined_categories?.[0]?.title,
    canonical: `https://shapeshiftingmastery.com/blogs/${blogData?.seo_url_slug || ''}`
  }),


  "services/:seo_url_slug": (service) => ({
    title: service?.seo_title_en || service?.title || "Service - Shape Shifting Mastery",
    description: service?.seo_description_en || `Read about ${service?.title} on Shape Shifting Mastery.`,
    keywords: service?.seo_keywords || "shape shifting mastery, body transformation, fitness journey, wellness tips",
    ogTitle: service?.seo_title_en || service?.title || "Service - Shape Shifting Mastery",
    ogDescription: service?.seo_description_en || `Read about ${service?.title} on Shape Shifting Mastery.`,
    ogImage: service?.photo_file || "",
    canonical: `https://shapeshiftingmastery.com/services/${service?.seo_url_slug || ''}`
  }),

"podcasts/:seo_url_slug": (PodcastData) => ({
  title: `${PodcastData.seo_title_en || PodcastData.title} - Shape Shifting Mastery`,
  description: PodcastData.seo_description_en || `Read about ${PodcastData.title} on Shape Shifting Mastery.`,
  keywords: PodcastData.seo_keywords || 'shape shifting mastery, body transformation, fitness journey',
  ogTitle: `${PodcastData.seo_title_en || PodcastData.title} - Shape Shifting Mastery`,
  ogDescription: PodcastData.seo_description_en || `Read about ${PodcastData.title} on Shape Shifting Mastery.`,
  ogImage: PodcastData.photo_file,
  author: PodcastData.user.name,
  }),

"shop/:categorySlug/:productSlug": (productData) => ({
  title: `${productData.seo_title_en || productData.title} - Shape Shifting Mastery`,
  description: productData.seo_description_en || `Read about ${productData.title} on Shape Shifting Mastery.`,
  keywords: productData.seo_keywords || 'shape shifting mastery, body transformation, fitness journey',
  ogTitle: `${productData.seo_title_en || productData.title} - Shape Shifting Mastery`,
  ogDescription: productData.seo_description_en || `Read about ${productData.title} on Shape Shifting Mastery.`,
  ogImage: productData.photo_file,
  // author: productData.user.name,
  }),

};




console.log('META_TAGS Configuration Loaded:', {
  availablePages: Object.keys(META_TAGS),
  hasServicesConfig: Boolean(META_TAGS.services)
});